import { T } from "../lib/types/common";
import { Member, MemberInquiry } from "../lib/types/member";
import api from "../lib/axiosInstance";
import { Job, JobInquiry, JobUpdateInput } from "../lib/types/job";
import { MemberStatus } from "../lib/enums/member.enum";
import { JobStatus } from "../lib/enums/jobs.enum";

class AdminService {
  public async getStatsByAdmin(): Promise<{
    totalMembers: number;
    totalJobs: number;
  }> {
    try {
      const result = await api.get(`/admin/stats`);

      return result.data;
    } catch (err) {
      console.log("Error, getStatsByAdmin:", err);
      throw err;
    }
  }

  public async getMembersByAdmin(
    inquiry: MemberInquiry
  ): Promise<{ data: Member[]; totalCount: number }> {
    try {
      const result = await api.get(
        `/admin/member/all?page=${inquiry.page}&limit=${inquiry.limit}`
      );

      return result.data;
    } catch (err) {
      console.log("Error, getMembersByAdmin:", err);
      throw err;
    }
  }

  public async updateMemberByAdmin(
    memberId: string,
    status: MemberStatus
  ): Promise<{ data: Member[]; totalCount: number }> {
    try {
      const result = await api.post(`/admin/member/${memberId}/update`, {
        memberStatus: status,
      });

      return result.data;
    } catch (err) {
      console.log("Error, updateMemberByAdmin:", err);
      throw err;
    }
  }

  public async getJobsByAdmin(
    inquiry: JobInquiry
  ): Promise<{ data: Job[]; totalCount: number }> {
    try {
      const result = await api.get(
        `/admin/job/all?page=${inquiry.page}&limit=${inquiry.limit}`
      );

      return result.data;
    } catch (err) {
      console.log("Error, getMembersByAdmin:", err);
      throw err;
    }
  }

  public async updateJobByAdmin(
    jobId: string,
    input: JobUpdateInput
  ): Promise<{ data: Member[]; totalCount: number }> {
    try {
      const result = await api.post(`/admin/job/${jobId}/update`, input);

      return result.data;
    } catch (err) {
      console.log("Error, updateJobByAdmin:", err);
      throw err;
    }
  }

  public async getJobByAdmin(jobId: string): Promise<Job> {
    try {
      const result = await api.get(`/admin/job/${jobId}`);

      return result.data;
    } catch (err) {
      console.log("Error, getJobByAdmin:", err);
      throw err;
    }
  }
}

export default AdminService;
